import { isDateControl, rankWith } from "@jsonforms/core";

export default rankWith(5, isDateControl);
